// extracted by mini-css-extract-plugin
export default {"icon":"About_icon__pS-Gb","content":"About_content__tnRuc","contentFoot":"About_contentFoot__WpQML"};